<template>
  <LayoutDefault>
    <div
            class="container dark"
            id="membership"
    >
      <template v-if="$auth.ready() && $auth.check()">
        <div class="blocks">
          <section class="block subscription-status">
<!--            <MembershipStatus/>-->
            <div class="recurring-status-container">
              <RecurringStatusTable/>
            </div>
          </section>
          <section class="block payments">
            <PaymentsTable
              v-if="subscription_id"
              :key="subscription_id"
              :subscription_id="subscription_id"
            />
          </section>
        </div>
      </template>
    </div>
  </LayoutDefault>
</template>

<script>
import RecurringStatusTable from '../components/RecurringStatusTable';
import LayoutDefault from "../layouts/LayoutDefault";
import MembershipStatus from "../components/MembershipStatus";
import PaymentsTable from "../components/PaymentsTable";
import EventBus from "../eventbus";

export default {
      components: {
        PaymentsTable,
        MembershipStatus,
        LayoutDefault,
        RecurringStatusTable,
      },
      data(){
        return {
            user: null,
            subscription_id: null
        }
      },
      mounted(){
        EventBus.$on('loadPayments', this.setSubscriptionId);
      },
      methods:{
        setSubscriptionId(subscription_id){
          this.subscription_id = subscription_id;
          this.scrollToPayments();
        },
        scrollToPayments() {
          const el = this.$el.getElementsByClassName('payments')[0];
          el && el.scrollIntoView({behavior: 'smooth'});
        },
      },
      watch: {
          $auth: function(){
              //console.log(this.$auth.user());
          }
      },
    }
</script>

<style scoped lang="scss">
  @import '../styles/variables';
  @import '../styles/classes';

  #membership{
    box-sizing: border-box;
    min-height: 500px;
    padding: 9px;
    padding-top: 100px;

    .banners{
      .banner{
        height: 400px;
        background-size: cover;
        background-position: center;
      }
    }

    .blocks{
      display: block;
      margin-bottom: 100px;

      .block.subscription-status{
        display: block;
        margin: auto;
        width: 75%;

        @media(max-width: 900px){
          width: auto;
        }
      }

      .block.payments{
        margin: 60px auto 0 auto;
        display: block;
        width: 75%;

        @media(max-width: 1280px){
          width: 80%;
        }

        @media(max-width: 900px){
          width: auto;
        }
      }

      .block.personal-data{
        text-align: center;
        flex-basis: 50%;
      }
    }
  }
</style>

<style lang="scss">
  #membership{
    .block.payments{
      table{
        min-width: 600px;
      }
    }
  }
</style>